import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-employee-select-dialog',
  templateUrl: './employee-select-dialog.component.html',
  styleUrls: ['./employee-select-dialog.component.scss']
})
export class EmployeeSelectDialogComponent extends DialogContentBase implements OnInit {

  constructor( public dialog: DialogRef,
    private fb:UntypedFormBuilder) {   super(dialog);  }

  @Input() caption:string;
  @Input() selectedEmployeeId:string;
  form: UntypedFormGroup;

  ngOnInit(): void {
    if(!this.selectedEmployeeId){
      this.selectedEmployeeId = '';
    }
    this.form = this.getForm();
  }

  confirm(){
    const result = this.form.controls['selectedEmployeeId'].value;
        this.dialog.close({ text: 'OK' , selectedEmployeeId: result});
  }

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  getForm( ) {
    return this.fb.group({
      selectedEmployeeId: [this.selectedEmployeeId, Validators.required],
    });
  }
}
